<template>
  <div>
    <header class="header header--main container-fluid flex-nowrap flex--justify-space-between">
      <div class="header__item flex flex--align-vertical">
        <!-- Logo -->
        <div class="header__logo mr10">
          <router-link :to="{name: linkToMainPage}">
            <img src="/static/images/logo/logo-icon-v2.svg" alt="Koncepted Platform">
          </router-link>
        </div>

        <!-- Navigation -->
        <nav role="navigation" :class="[{closed: !open}, {open: open}, {closing: !open}]">
          <ul class="flex mb0 ml10 ml0-sm-down pl0">
            <router-link :to="{name: 'schedule'}" tag="li"
              v-if="checkUserRole(user.role, ['admin', 'projectManager', 'designer'])">Schedule</router-link>
            <router-link :to="{name: 'tasks'}" tag="li"
              v-if="checkUserRole(user.role, ['admin', 'projectManager', 'designer'])">Tasks</router-link>
            <router-link :to="{name: 'projects'}" tag="li">Projects</router-link>
            <router-link class="relative" :to="{name: 'messages'}" tag="li"
              v-if="checkUserRole(user.role, ['admin', 'projectManager', 'designer'])">Messages  
              <span v-if="messagesCount !== 0" class="badge badge--messages text-space-05 text-uppercase ml2 mb0">
                {{messagesCount}}
              </span>
            </router-link>

            <li class="flex flex--align-vertical flex--justify-center" v-if="checkUserRole(user.role, ['admin', 'projectManager'])">
              <dropdown :selectable="false" :buttonText="'Users'" :buttonIconName="'text-size-15 icon-chevron-down'"
                class="dropdown--header-links">
                <template slot="items" slot-scope="props">
                  <router-link :to="{name: 'users'}" tag="li">Users</router-link>
                  <router-link :to="{name: 'designers'}" tag="li">Designers</router-link>
                </template>
              </dropdown>
            </li>
            <router-link :to="{name: 'settings'}" tag="li">Settings</router-link>
            <li @click="$bus.$emit('modalShow', ['project-create-modal', {userRole: user.role, userEmail: user.email}])"
                v-if="($route.name === 'tasks' || $route.name === 'projects') && checkUserRole(user.role, ['admin', 'projectManager', 'customer'])"><span class="icon-plus ml0 mr5"></span>
              New Project
            </li>
          </ul>
        </nav>
      </div>

      <!-- User -->
      <div class="header__item header__item--middle flex-nowrap flex--align-vertical flex-nowrap mr20-xs-down mr30-sm-down">
        <a class="link link--gray text-size-12 hidden-sm-down text-medium text-uppercase text-spase-2 mr20"
          @click="$bus.$emit('modalShow', ['add-user-modal'])" v-if="$route.name === 'users'">
          <span class="icon-plus ml0 mr5"></span>
          Add User
        </a>

        <a class="link link--gray text-size-12 text-medium text-uppercase text-spase-2 mr20" @click="onLogout">Logout</a>
        <div class="header__user flex flex--row flex--align-vertical">
          <!-- Avatar + Username -->
          <router-link :to="{name: 'settings'}" class="flex flex--align-vertical
            flex-nowrap">
            <img :src="'/serve/s/' + user.avatarKey + '?w=48&h=48'" class="img-circle img-circle--24 mr10"
                 alt="User Avatar" v-if="user.avatarKey">
            <img src="/static/images/user/user-avatar-demo@2x.png" class="img-circle img-circle--24 mr10"
                 alt="User Avatar" v-else>
             <!-- Designer Hours -->
            <div class="text-ellipsis-wrap">
              <p class="header__user--username text-ellipsis-block">{{user.name}} {{user.surname}}</p>

              <i v-if="isWorkLogDataLoading" class="icon--rectangle icon--rectangle-tall icon--rectange-dark-gray"></i>
              <tooltip v-else-if="workLogData">
                <template slot="reference">
                  <h6 class="header__user--hours w-100 cursor-pointer text-ellipsis-block">{{currentPeriodStartDate | shortMonth}} {{currentPeriodAmount}}h</h6>
                </template>
                <template slot="content">

                    <ul class="header__user-worklog header__worklog-dropdown">
                      <li v-for="item in workLogData" :key="item.fromTs" :class="{ 'pointer-events-none' : item.amount === 0}">
                        <details class="w-100">
                          <summary :class="['w-100' ,'header__worklog-summary', {'header__worklog-summary-disabled': item.amount === 0}]"><div :class="['header__worklog-item', {'header__worklog-item-no-hours': amountSum === 0}]">{{item.fromTs | shortDate}} - {{item.toTs | shortDate}}<span class="text-color-white mlauto">{{item.amount}}</span></div></summary>
                            <div class="header__worklog-project-item" v-for="(amount, projectName) in item.perProject" :key="projectName">
                              {{projectName}} <span class="text-color-white mlauto">{{amount}}</span>
                            </div>
                        </details>                        
                      </li>
                    </ul>
           
                </template>
              </tooltip>

            </div>
            <!-- Designer Hours END -->
          </router-link>
          <!-- Avatar + Username END -->
        </div>
      </div>

      <div class="header__item flex-nowrap flex--align-vertical visible-sm-down-flex">
        <button class="btn-simple flex-none visible-sm-down-block" @click="$bus.$emit('modalShow', ['add-user-modal'])"
                v-if="$route.name === 'users'">Add User
        </button>

        <button type="button" @click="toggleMenu" class="header__menu-btn" :class="{open: open}">
          <span></span>
        </button>
      </div>
    </header>
  </div>
</template>

<script>
  import CheckUserRoleMixin from 'modules/mixins/CheckUserRole'
  import { mapGetters } from 'vuex'
  import moment from 'moment';
  import { mixin as clickaway } from 'vue-clickaway'

  import DropdownSimple from 'components/common/DropdownSimple'
  import Tooltip from 'components/common/Tooltip'

  export default {
    name: 'app-header',

    mixins: [CheckUserRoleMixin, clickaway],

    components: {
      'dropdown-simple': DropdownSimple,
      Tooltip
    },

    data () {
      return {
        open: false
      }
    },

    computed: {
      ...mapGetters({
        user: 'getUser',
        isWorkLogDataLoading: 'getIsWorkLogDataLoading',
        workLogData: 'getWorkLogData',
        currentPeriodAmount: 'getCurrentPeriodAmount',
        currentPeriodStartDate: 'getCurrentPeriodStartDate',
        amountSum: 'getAmountSum',
        messagesCount: 'getMessagesCount'
      }),

      linkToMainPage () {
        return this.checkUserRole(this.user.role, ['admin', 'projectManager', 'designer']) ? 'tasks' : 'projects'
      }
    },

    methods: {
      onLogout () {
        this.$bus.$emit('logout')
      },

      toggleMenu () {
        this.open = !this.open
      }
    },

    filters: {
      shortDate (val) {
        return moment.utc(val).format('D. MMM')
      },

      shortMonth (val) {
        return moment.utc(val).format('MMM')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Header.vue?76738c89